export default __webpack_public_path__ + "static/media/arrow.0a96b237.svg";